import { Component, OnInit } from '@angular/core';
import { AuthService } from './services/auth.service';
import { AiWakeupService } from './services/ai-wakeup.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'web-app';
  
  constructor(
    private authService: AuthService,
    private aiWakeupService: AiWakeupService
  ) {}

  ngOnInit(): void {
    this.authService.restoreSessionFromLocalStorage();
    
    // Start AI wakeup service if user is authenticated
    const user = this.authService.userValue;
    
    if (user) {
      this.aiWakeupService.startWakeupService();
    }
  }
}
